import { Label } from '../ui/label';
import { Button } from '../ui/button';
import type { Participant } from '../../types';

interface ParticipantSelectorProps {
  participants: Participant[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  label?: string;
}

export function ParticipantSelector({
  participants,
  selectedIds,
  onChange,
  label = 'Dividir entre',
}: ParticipantSelectorProps) {
  const handleToggle = (id: string) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((p) => p !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  const handleSelectAll = () => {
    onChange(participants.map((p) => p.id));
  };

  const handleSelectNone = () => {
    onChange([]);
  };

  const allSelected = selectedIds.length === participants.length;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>{label}</Label>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-7 text-xs"
          onClick={allSelected ? handleSelectNone : handleSelectAll}
        >
          {allSelected ? 'Ninguno' : 'Todos'}
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto">
        {participants.map((participant) => (
          <label
            key={participant.id}
            className={`flex items-center gap-2 p-2 rounded-md border cursor-pointer transition-colors ${
              selectedIds.includes(participant.id)
                ? 'border-primary bg-primary/5'
                : 'border-border hover:bg-accent/50'
            }`}
          >
            <input
              type="checkbox"
              checked={selectedIds.includes(participant.id)}
              onChange={() => handleToggle(participant.id)}
              className="h-4 w-4 rounded border-input"
            />
            <span className="text-sm truncate">{participant.name}</span>
          </label>
        ))}
      </div>
      {selectedIds.length > 0 && (
        <p className="text-xs text-muted-foreground">
          {selectedIds.length} de {participants.length} seleccionados
        </p>
      )}
    </div>
  );
}
